// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import PuertoRico from '../_raw/flag/icon_flag_puerto_rico.png';

export default () => <img src={PuertoRico} alt="PuertoRico" />;
